import React, {useEffect} from "react";
import Styles from './styles.module.scss';
import {useDispatch, useSelector} from "react-redux";
import {getMatrix, getWalletHistory} from "../../store/cabinet/action";
import {useNavigate} from "react-router-dom";
import CabinetWalletMain from "../../components/cabinetWalletMain";
import CabinetWalletExchange from "../../components/cabinetWalletExchange";
import CabinetWalletHistory from "../../components/cabinetWalletHistory";
import CabinetWalletBuyModal from "../../components/cabinetWalletBuyModal";
import CabinetGoogleAuthenticatorModal from "../../components/cabinetGoogleAuthenticatorModal";



const CabinetWalletPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const authStatus = useSelector(store => store.main.authorizationStatus);

    useEffect(()=>{
        if (!authStatus){
            navigate('/sign-in');
        }
    },[authStatus, navigate])

    useEffect(() => {
        dispatch(getMatrix());
        dispatch(getWalletHistory());
    }, [dispatch]);

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap}`}>
                <CabinetWalletMain/>
                <CabinetWalletExchange/>
                <CabinetWalletHistory/>
                <CabinetWalletBuyModal/>
                <CabinetGoogleAuthenticatorModal/>
            </div>
        </section>
    );
};

export default CabinetWalletPage;
